/* unplugin-vue-components disabled */import script from "./BookingViewActions.vue?vue&type=script&setup=true&lang=js"
export * from "./BookingViewActions.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__